import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
import { Heading } from '@myxplor/ui'
import ApprovalForm from '../../approval-form'

const ExportForm = ({ loading, errors, submitAction }) => (
  <div>
    <Heading>Export Enrolments</Heading>
    <ApprovalForm
      loading={loading}
      errors={errors}
      submitAction={submitAction}
      submitText='Download CSV'
    />
    <FormDisplayErrors errors={errors.export} loading={loading} />
  </div>
)

export default ExportForm



// WEBPACK FOOTER //
// ./src/export/views/form.jsx